import Carousel from "./Carousel";

export const UserTestimonials = ({ userTestimonials }) => {
	const testimonials = userTestimonials?.map((testimonial, index) => (
		<div
			key={index}
			className="flex flex-col gap-2 text-is2-gray-300 text-sm  w-[100vw] m-auto px-10 md:p-0 md:m-0 md:w-1/4 "
		>
			{testimonial}
		</div>
	));
	return (
		<>
			<div className="hidden md:flex flex-row items-start justify-center gap-12 my-8 ">{testimonials}</div>

			<div className="block md:hidden mt-12">
				<Carousel items={testimonials} buttonType={"circle"} />
			</div>
		</>
	);
};
